import { Injectable } from '@angular/core';
import { Observable }from 'rxjs'
import { of } from 'rxjs/observable/of'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import * as globals from './globals';

@Injectable()
export class EnviarEmailService {
  private faleconoscoUrl = globals.URL+'/enviar_faleconosco.php';
  private trabalheconoscoUrl = globals.URL+'/enviar_trabalheconosco.php'
  constructor(private http: HttpClient) { }
  
  enviarDados(contato:any): Observable<any>{
    console.log(contato)
    let formData:FormData = new FormData();
    formData.append('nome', contato.nome);
    formData.append('email', contato.email);
    formData.append('telefone', contato.telefone);
    formData.append('assunto', contato.assunto);
    formData.append('mensagem', contato.mensagem);
    //let headers = new Headers();
    /** In Angular 5, including the header Content-Type can invalidate your request */
    //headers.append('Content-Type', 'multipart/form-data');
    //headers.append('Accept', 'application/json');
    //let options = new RequestOptions({ headers: headers });
    var observable = this.http.post(this.faleconoscoUrl, formData)
    return observable

  }
  enviarDadosTrabalhador(trabalhador:any): Observable<any>{
    console.log(trabalhador)
    let formData:FormData = new FormData();
    formData.append('nome', trabalhador.nome);
    formData.append('nascimento', trabalhador.nascimento);
    formData.append('sexo', trabalhador.sexo);
    formData.append('estado_civil', trabalhador.estado_civil);
    formData.append('formacao', trabalhador.formacao);
    formData.append('area_interesse', trabalhador.area_interesse);
    formData.append('email', trabalhador.email);
    formData.append('telefone', trabalhador.telefone);
    formData.append('endereco', trabalhador.endereco);
    formData.append('cidade', trabalhador.cidade);
    formData.append('ultimo_emprego', trabalhador.ultimo_emprego);
    formData.append('empresa', trabalhador.empresa);
    formData.append('cidade_emprego', trabalhador.cidade_emprego);
    formData.append('cargo', trabalhador.cargo);
    formData.append('descricao_cargo', trabalhador.descricao_cargo);
    formData.append('entrada', trabalhador.entrada);
    formData.append('saida', trabalhador.saida);
    //let headers = new Headers();
    /** In Angular 5, including the header Content-Type can invalidate your request */
    //headers.append('Content-Type', 'multipart/form-data');
    //headers.append('Accept', 'application/json');
    //let options = new RequestOptions({ headers: headers });
    var observable = this.http.post(this.trabalheconoscoUrl, formData)
    return observable

  }
}



// WEBPACK FOOTER //
// ./src/app/enviaremail.service.ts